module.exports = __webpack_public_path__ + "img/banner.1.99981c2a.png";